import { render, staticRenderFns } from "./change-email-tfa.vue?vue&type=template&id=157f5f35&scoped=true"
import script from "./change-email-tfa.vue?vue&type=script&lang=js"
export * from "./change-email-tfa.vue?vue&type=script&lang=js"
import style0 from "./change-email-tfa.vue?vue&type=style&index=0&id=157f5f35&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f5f35",
  null
  
)

export default component.exports